import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Badge } from "@faire/web--source/slate/deprecated/Badge";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { TypographyStyles } from "@faire/web--source/ui/Typography";
import * as React from "react";
import styled, { css } from "styled-components";
export var ShowroomBadge = function(param) {
    var className = param.className, onMouseEnter = param.onMouseEnter, small = param.small;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(StyledBadge, {
        content: strictLocalize({
            id: "elHgYp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Showroom"
                }
            ]
        }),
        backgroundColor: Core.surface.enabled,
        contentColor: Core.text.inverse,
        borderColor: Core.border.hover,
        className: className,
        onMouseEnter: onMouseEnter,
        smallSizeBadge: small,
        "data-test-id": "showroom-badge"
    });
};
var StyledBadge = styled(Badge).withConfig({
    componentId: "sc-9f7285b8-0"
})([
    "",
    ";cursor:default;",
    ";border-radius:4px;"
], function(param) {
    var smallSizeBadge = param.smallSizeBadge;
    return TypographyStyles({
        weight: "medium",
        color: "white",
        small: smallSizeBadge
    });
}, function(param) {
    var smallSizeBadge = param.smallSizeBadge;
    return smallSizeBadge ? css([
        "padding:",
        ";"
    ], getSpacing(3, 7)) : css([
        "padding:",
        ";"
    ], getSpacing(4, "1x"));
});
